var map = {
	"./AntMall/logo.svg": 62869,
	"./Argos/logo.svg": 28156,
	"./ArgosShop/logo.svg": 16064,
	"./EShop/logo.svg": 52801,
	"./FamilyMart/logo.svg": 45186,
	"./FamilyShop/logo.svg": 93970,
	"./GreenMall/logo.svg": 75887,
	"./Hive/logo.svg": 26220,
	"./INT Overstock/logo.svg": 2295,
	"./Iceland/logo.svg": 44984,
	"./Inchoi/logo.svg": 97246,
	"./Just Shop/logo.svg": 59852,
	"./Laz/logo.svg": 50541,
	"./Mbuy/logo.svg": 80243,
	"./MetaShop/logo.svg": 82631,
	"./SM-wholesale shop/logo.svg": 6521,
	"./Shop2u/logo.svg": 29963,
	"./Shopee/logo.svg": 37608,
	"./TikTok-Wholesale/logo.svg": 3853,
	"./Tongda/logo.svg": 72291,
	"./Zalando/logo.svg": 91087
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54224;